<div [ngClass]="{ 'message-container': !isAuthor && forward }">
  <div [ngClass]="{ 'selected-cover': isForwardChecked }"></div>
  <mat-checkbox
    *ngIf="!isAuthor && forward"
    [ngStyle]="{
      visibility: msg.active ? 'visible' : 'hidden',
      'padding-left': '32px'
    }"
    [checked]="isForwardChecked"
    (change)="selectForward($event)"
  ></mat-checkbox>
  <div
    class="message-box-container"
    [ngStyle]="{
      'justify-content': !isAuthor ? 'flex-start' : 'flex-end'
    }"
  >
    <div
      *ngIf="!isAuthor"
      class="message-box-triangle-and-border-left-container"
    >
      <div class="message-box-triangle-left"></div>
      <div class="message-box-border-left"></div>
    </div>

    <div class="message-box-author-and-text-container-father">
      <div
        class="message-box-author-and-text-container"
        (mouseenter)="mouseOn = true; contextMenuVisibility = 'visible'"
        (mouseleave)="mouseOn = false; setContextMenuVisibility()"
        (touchOutside)="onTouchOutside()"
        touchLongPress
        [duration]="500"
        (longPress)="touchLongPress()"
      >
        <div class="forward-message">{{ forwardStatus }}</div>
        <div [ngClass]="{ 'message-header': !isAuthor }">
          <span *ngIf="!isAuthor" class="message-author">
            {{ msg.authorName }}
          </span>
          <div
            *ngIf="(showContextMenu() || showForwardMenu) && msg.active"
            class="context-menu"
            [ngStyle]="{ visibility: contextMenuVisibility }"
          >
            <button
              class="context-menu-button"
              [matMenuTriggerFor]="aboveMenu"
              #menuTrigger="matMenuTrigger"
              (menuClosed)="
                contextMenuImage = 'expand_more'; setContextMenuVisibility()
              "
              (menuOpened)="contextMenuImage = 'expand_less'"
            >
              <span class="material-icons" (clickOutside)="onClickOutside()">
                {{ contextMenuImage }}
              </span>
            </button>
            <mat-menu
              [hasBackdrop]="false"
              #aboveMenu="matMenu"
              xPosition="before"
              yPosition="above"
            >
              <button
                *ngIf="showContextMenu()"
                mat-menu-item
                (click)="deleteMessageClick()"
              >
                Deletar
              </button>
              <button
                *ngIf="showForwardMenu"
                (click)="forwardMessage(true)"
                mat-menu-item
              >
                Encaminhar
              </button>
            </mat-menu>
          </div>
        </div>

        <div *ngIf="msg.active; else deletedMessage">
          <span
            *ngIf="msg.files && msg.files.length < 1"
            class="message-text"
            [innerHTML]="msg.text.replaceAll('\n', '<br>') | transformLink"
          >
          </span>
          <div *ngIf="msg.text && !msg.files">
            <span
              *ngIf="msg.text"
              class="message-text"
              [innerHTML]="msg.text.replaceAll('\n', '<br>') | transformLink"
            >
            </span>
          </div>
          <div *ngIf="(msg.files && msg.files.length > 0) || msg.attachment">
            <div class="message-file-box-container-father">
              <!-- upload -->
              <div
                *ngIf="!msg.id; else downloadComponent"
                class="message-file-box-container"
              >
                <div class="message-file-box-item">
                  <app-chat-file [fileName]="msg.attachment.file!.name">
                  </app-chat-file>
                  <app-chat-file-uploader
                    *ngIf="
                      msg.attachment && !msg.attachment.hasError && !msg.id
                    "
                    (onCancel)="uploadCanceled()"
                    (onSuccess)="uploadSuccessed($event)"
                    [file]="msg.attachment.file"
                  ></app-chat-file-uploader>
                </div>
              </div>
              <!-- download -->
              <ng-template #downloadComponent>
                <div *ngFor="let itemFile of msg.files">
                  <div class="message-file-box-container">
                    <div class="message-file-box-item">
                      <app-chat-file [fileName]="getFileName(itemFile)">
                      </app-chat-file>
                      <app-chat-file-downloader
                        [file]="createFileDownload(msg.id, itemFile)"
                        (onError)="handleDownloadError()"
                      ></app-chat-file-downloader>
                    </div>
                    <div>
                      <span
                        *ngIf="formatBytes(itemFile) !== ''"
                        class="download-image-subtitle"
                      >
                        {{ fileExtension(itemFile.fileName) }} |
                        {{ formatBytes(itemFile) }} |
                        {{ msg.dtMessage | date : "HH:mm - dd/MM/yyyy" }}
                      </span>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <ng-template #deletedMessage>
          <app-chat-removed-message [isAuthorMessage]="isAuthor">
          </app-chat-removed-message>
        </ng-template>
        <div
          class="date-and-visualized-container"
          *ngIf="
            (msg.attachment && !msg.attachment.hasError) || !msg.attachment;
            else uploadErrorMsg
          "
        >
          <span class="message-date" *ngIf="msg.sendStatus !== messageSendStatus.ERROR">
            {{ msg.dtMessage | date : "HH:mm - dd/MM/yyyy" }}
          </span>

          <div class="status-wrapper" *ngIf="isAuthor && !msg.id && msg.active">
            <!-- PENDING -->
            <div *ngIf="msg.sendStatus === messageSendStatus.PENDING && !isOnline">
              <span class="material-icons">schedule</span>
            </div>

            <!-- ERROR -->
            <div *ngIf="msg.sendStatus === messageSendStatus.ERROR">
              <span class="msg-upload-error" (click)="itemDetails?.isRoomMessage ? retryRoom(msg) : retryUser(msg)">
                Falha ao enviar. <b>Tentar novamente</b>
              </span>
            </div>
          </div>

          <div *ngIf="isAuthor && msg.id && msg.active">
            <!-- rooms-message -->
            <div *ngIf="itemDetails && itemDetails.isRoomMessage">
              <ng-container
                *ngIf="responsibleOrStudentHasVisualized; then visualized; else notVisualized">
              </ng-container>

              <ng-template #notVisualized>
                <span class="material-icons icon-done">done</span>
              </ng-template>

              <ng-template #visualized>
                <span class="material-icons icon-done-all-visualized">done_all</span>
              </ng-template>
            </div>

            <!-- users-message -->
            <div *ngIf="itemDetails && !itemDetails.isRoomMessage">
              <span *ngIf="!msg.received" class="material-icons icon-done">
                done
              </span>
              <span
                *ngIf="msg.received && !msg.visualized"
                class="material-icons icon-done-all-received"
              >
                done_all
              </span>
              <span
                *ngIf="msg.received && msg.visualized"
                class="material-icons icon-done-all-visualized"
              >
                done_all
              </span>
            </div>
          </div>
          <div *ngIf="!msg.id && msg.sendStatus !== messageSendStatus.PENDING && msg.sendStatus !== messageSendStatus.ERROR">
            <span class="material-icons"> schedule </span>
          </div>
        </div>
        <ng-template #uploadErrorMsg>
          <span
            class="msg-upload-error"
            (click)="msg.attachment.hasError = false"
            >Falha ao enviar. <b>Tentar novamente</b>
          </span>
        </ng-template>
      </div>

      <div
        *ngIf="msg.attachment"
        class="upload-warning"
        [hidden]="!(msg.attachment && msg.attachment.hasError)"
      >
        <mat-icon svgIcon="custom-warning"></mat-icon>
      </div>
    </div>

    <div *ngIf="isAuthor" class="message-box-triangle-right-container">
      <div class="message-box-triangle-right"></div>
    </div>
  </div>
</div>
